import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://backend.rahiiq.shop/api",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("Token");

    // Only add if token exists and isn't null/empty
    if (token && token !== "null" && token !== null) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // Optional: Log a warning or handle missing token (e.g., redirect to login)
      console.warn("No valid token found. User may need to log in.");
      // You could delete the header or throw an error here if needed
      // delete config.headers.Authorization;
    }

    return config;
  },
  (error) => {
    // Handle interceptor errors if any
    return Promise.reject(error);
  }
);

// Optional: Add a response interceptor for handling 401 (unauthorized) errors globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid? Clear it and redirect to login
      localStorage.removeItem("Token");
      // window.location.href = '/login';  // Uncomment if you have a login route
      console.error("Unauthorized—token invalid. Redirecting to login.");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance; // Export it so you can import and use elsewhere
